import { useState, type CSSProperties, type ReactNode } from "react";

/**
 * Linha inteira clicavel, com realce no hover.
 *
 * Existe porque linha de lista que expande NAO comunicava que era clicavel: um
 * chevron discreto e nenhuma reacao ao mouse fazem a lista parecer estatica. E
 * como o projeto estiliza inline (sem `:hover` em CSS), o realce precisa vir de
 * estado. O <button> de verdade traz foco por teclado de brinde.
 */
export function RowButton({ children, onClick, style, titulo }: {
  children: ReactNode;
  onClick: () => void;
  style?: CSSProperties;
  /** Vira `title` — a dica em hover que diz o que o clique faz. */
  titulo?: string;
}) {
  const [hover, setHover] = useState(false);
  return (
    <button
      type="button"
      title={titulo}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: "100%", display: "flex", alignItems: "center", gap: 10,
        border: "none", cursor: "pointer", textAlign: "left", color: "var(--text)",
        background: hover ? "color-mix(in srgb, var(--accent) 9%, transparent)" : "transparent",
        transition: "background .15s",
        ...style,
      }}
    >
      {children}
    </button>
  );
}
